/** @description config light theme for vuetify */

/** @constant
 *   @type {boolean}
 *   @default true
 *  **/
const isDark = false;

//###########################################

export default {
  dark: isDark,
  colors: {
    background: '#FFFFFF',
    'ostadino':'#f9fAfB',
    surface: '#FFFFFF',
    primary: '#007AFF',
    'primary-darken-1': '#3700B3',
    secondary: '#757575',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  }
}
